<!-- 首页 -->
<template>
  <div class="page">
    <!-- 横幅 -->
    <Banner></Banner>
    <!-- 供应商招募 -->
    <SupplierRecruit></SupplierRecruit>
    <!-- 传统模式挑战 -->
    <TraditionalEnterprise></TraditionalEnterprise>
    <!-- 标语 -->
    <Slogan></Slogan>
    <!-- 一体化股管理 -->
    <IntegrationManage></IntegrationManage>
    <!-- 我们的能力 -->
    <OurAbility></OurAbility>
    <!-- 五大核心能力 -->
    <CoreAbility></CoreAbility>
    <!-- 核心亮点 -->
    <CoreBright></CoreBright>
    <!-- 多终端适配 -->
    <MultiTerminalAdapt></MultiTerminalAdapt>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import SupplierRecruit from "./components/SupplierRecruit.vue";
import TraditionalEnterprise from './components/TraditionalEnterprise.vue';
import Slogan  from './components/Slogan.vue';
import IntegrationManage from './components/IntegrationManage.vue';
import OurAbility from './components/OurAbility.vue';
import CoreAbility from './components/CoreAbility.vue';
import CoreBright from './components/CoreBright.vue';
import MultiTerminalAdapt from './components/MultiTerminalAdapt.vue';

export default {
  components: {
    Banner,
    SupplierRecruit,
    TraditionalEnterprise,
    Slogan,
    IntegrationManage,
    OurAbility,
    CoreAbility,
    CoreBright,
    MultiTerminalAdapt,
  },
  methods:{
    refreshView(){
      window.location.reload()
    }
  }
};
</script>

<style lang="less" scoped>
</style>
